import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DtpContentContainer, DtpNoContent } from 'dtp-react-components';
import { Table, Button } from '../../../components/index';
import { doGet } from '../../../utils/requests';
import * as constantes from '../../../utils/constants';
import FiltroPesquisa from '../../consultas/FiltroPesquisa';
import * as listUtils from '../../../utils/listsSelect';

class Indeferido extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaRequerimentosFiltrada: null,
      listaRequerimentosIndexada: [],
      listaRequerimentosIndexadaAtualizada: false,
      showNoContent: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosPesquisa: {},
    };
  }

  componentDidMount() {
    if (!sessionStorage.getItem('filtroPesquisa')) {
      this.realizarConsulta();
    }
  }

  realizarConsulta = (filtrosPesquisa) => {
    let filtrosConsulta = {};
    if (filtrosPesquisa) {
      filtrosConsulta = this.montarFiltros(filtrosPesquisa);
    }

    const atributosConsulta = constantes.estadosParaConsulta.indeferido;
    filtrosConsulta.estado = atributosConsulta.estados;
    filtrosConsulta.participacao = atributosConsulta.tipoParticipacao;

    this.setState({ ...this.state, filtrosConsulta }, this.executarConsulta);
  }

  executarConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      doGet(
        'requerimentos-compensacao',
        this.tratarSucesso,
        this.tratarErro,
        {
          ...this.state.filtrosConsulta,
          'unidade-inss': this.lotacao,
          'start-position': primeiroItem,
          'max-results': resultadosPorPagina,
        },
      );
    } else {
      this.setState({ listaRequerimentosIndexada: [], listaRequerimentosIndexadaAtualizada: true });
    }
  }

  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '') {
      this.setState({
        showNoContent: false,
        listaRequerimentosIndexada: [],
        listaRequerimentosIndexadaAtualizada: true,
        estadoTabela,
      });
    } else {
      this.setState({
        showNoContent: false,
        listaRequerimentosIndexada: response.data,
        listaRequerimentosIndexadaAtualizada: true,
        estadoTabela,
      });
    }
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: 'Requerimento Indeferido não encontrado.',
            noContentSecondaryMessage: 'Informe um protocolo válido.',
          });
        } else {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: `${data.mensagem}`,
            noContentSecondaryMessage: `${data.descricao}`,
          });
        }
      } else {
        this.setState({
          showNoContent: true,
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  tratarFiltroNaLista = (listaRequerimentosFiltrada) => {
    this.setState({ listaRequerimentosFiltrada, listaRequerimentosIndexadaAtualizada: false });
  }

  paginarResultado = (pagina, page) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.paginaAtual = pagina;
    if (pagina === 0) {
      estadoTabela.paginaAtual = 1;
    } else {
      estadoTabela.paginaAtual = pagina;
    }

    if (page) {
      estadoTabela.resultadosPorPagina = page;
    }

    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizarConsulta());
  }

  montarFiltros = (atributosPesquisa) => {
    let atributos = {
      participacao: atributosPesquisa.participacao,
      'unidade-inss': this.lotacao,
    };

    if (atributosPesquisa.cpf) {
      atributos = { ...atributos, cpf: atributosPesquisa.cpf };
    }

    if (atributosPesquisa.tipoRequerimento) {
      atributos = { ...atributos, 'tipo-requerimento': atributosPesquisa.tipoRequerimento };
    }

    if (atributosPesquisa.estado) {
      atributos = { ...atributos, estado: atributosPesquisa.estado };
    }

    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    if (atributosPesquisa.cliqueiNoBotao === 1) {
      this.state.estadoTabela.paginaAtual = 1;
    }

    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  recuperarColunas = () => {
    const cabecalhoTabela = [{
      id: 'cpf',
      label: 'CPF',
    }, {
      id: 'nome',
      label: 'Nome',
    }, {
      id: 'matricula',
      label: 'Matrícula',
    }, {
      id: 'nomeSolicitante',
      label: 'Solicitante',
    }, {
      id: 'nomeDestinatario',
      label: 'Destinatário',
    }, {
      id: 'tipoRequerimento',
      label: 'Tipo',
      dataFormat: this.addTipoRequerimentoLabel,
    }];

    if (this.props.auth.checkPermission(['requerer-compensacao-rgps'])) {
      cabecalhoTabela.push({
        id: 'dataCreditoPagamento',
        label: 'Data de Crédito do Pagamento',
      });
    } else {
      cabecalhoTabela.push({
        id: 'dataHomologacaoTribunalContas',
        label: 'Data de Homologação no Tribunal de Contas',
      });
    }

    cabecalhoTabela.push({
      id: 'acoes',
      label: 'Ações',
      dataFormat: this.createActionColumn,
    });

    return cabecalhoTabela;
  }

  addTipoRequerimentoLabel = tipo => (
    listUtils.getObject(listUtils.tipoRequerimento, tipo).label
  )

  createActionColumn = (cell, row) => {
    const botaoAcaoEditarRequerimentoIndeferido = (
      <Button
        hint="Alterar requerimento"
        icon="ico-doc-pencil"
        mini
        onClick={() => this.editarRequerimento(row)}
      />
    );

    return (
      <React.Fragment>
        {botaoAcaoEditarRequerimentoIndeferido}
      </React.Fragment>
    );
  }

  editarRequerimento = (requerimento) => {
    let tipo = 'pensao';
    if (requerimento.tipoRequerimento === 1) {
      tipo = 'aposentadoria';
    }

    this.props.history.push(`/requerimento/${tipo}/${requerimento.protocolo}/indeferidos`);
  }

  render() {
    const options = {
      noDataText: 'Nenhum requerimento a ser exibido',
      hideSizePerPage: false,
      onPageChange: this.paginarResultado,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
      sizePerPageList: listUtils.linhasPorPagina,
    };

    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };

    const colunas = this.recuperarColunas();

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <FiltroPesquisa
            handleSearchFilter={this.realizarConsulta}
            handleChangeList={this.tratarFiltroNaLista}
            list={this.state.listaRequerimentosIndexada}
            tipoConsulta="indeferido"
            listaRequerimentosIndexadaAtualizada={this.state.listaRequerimentosIndexadaAtualizada}
            auth={this.props.auth}
          />

          <Table
            bordered
            pagination
            remote
            legend="Requerimentos Indeferidos"
            data={this.state.listaRequerimentosFiltrada !== null ?
              this.state.listaRequerimentosFiltrada : this.state.listaRequerimentosIndexada}
            options={options}
            fetchInfo={fetchInfo}
            listaTableHeader={colunas}
          />
        </DtpContentContainer>
      )
    );
  }
}

Indeferido.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
};

export default connect()(Indeferido);



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Indeferido/Indeferido.jsx